class SubmenuFilterButton extends HTMLElement {
  constructor() {
    super();
    this.filterBtn = null;
    this.filtersComponent = null;
    this.filtersColumn = null;
    this.productsList = null;
  }

  connectedCallback() {
    this.filterBtn = this.querySelector('.submenu-filter-btn');

    if (!this.filterBtn) return;

    this.filtersComponent = document.querySelector('facet-filters');
    this.filtersColumn = document.querySelector('.main-products-grid__filters');
    this.productsList = document.querySelector('.main-products-grid__results > .grid');

    this.filterBtn.addEventListener('click', this.handleFilterClick);
  }

  disconnectedCallback() {
    if (this.filterBtn) {
      this.filterBtn.removeEventListener('click', this.handleFilterClick);
    }
  }

  handleFilterClick = () => {
    this.filterBtn.classList.toggle('is-active');
    const filtersOpen = this.filterBtn.classList.contains('is-active');
    this.filterBtn.setAttribute('aria-expanded', filtersOpen);

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    if (isDesktop && this.filtersColumn) {
      this.toggleDesktopFilters(filtersOpen);
    } else if (this.filtersComponent) {
      this.filtersComponent.open();
    }
  }

  toggleDesktopFilters(filtersOpen) {
    this.filtersColumn.classList.toggle('lg:js-hidden', !filtersOpen);

    if (this.productsList) {
      this.productsList.className = filtersOpen
        ? this.productsList.dataset.filtersOpenClasses
        : this.productsList.dataset.filtersClosedClasses;
    }
  }
}

if (!customElements.get('submenu-filter-button')) {
  customElements.define('submenu-filter-button', SubmenuFilterButton);
}
